<template>
    <div>
      <div class="main">
            <router-link to="/" class="onboarding-close">
                <span class="icon-close-large"></span>
            </router-link>
            <div class="container"> 
              <div class="row center middle onboarding-wrap">
                  <div class="col-lg-4 col-sm-6 col-md-9 col-xs-11">
                      <div class="onboarding-logo">
                        <img src="/static/images/logo-onboarding.svg" alt="" />
                      </div>
                      <form class="form" @submit.prevent>
                          <div class="row">
                              <div class="col-lg-12">
                                  <input-widget :placeholder="$t('label.email')"
                                    validate="required|email"
                                    v-model.trim="email">
                                  </input-widget>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-lg-12">
                                  <input-widget :placeholder="$t('label.password')"
                                    type="password"
                                    validate="required"
                                    v-model.trim="password">
                                  </input-widget>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-lg-12">
                                  <input-widget :placeholder="$t('label.password_confirmation')"
                                    type="password"
                                    validate="required"
                                    v-model.trim="password_confirmation">
                                  </input-widget>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-lg-12">
                                  <br />
                                  <button :class="{ 'button-full': true, 'loading': loading }" @click="validateForm" type="submit">{{ $t("button.submit") }}</button>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>      
        </div>
    </div>
</template>

<script>
  import auth from '@/auth'
  import InputWidget from '@/components/widgets/InputWidget'

  export default {
    name: 'ResetPasswordPage',
    components: {InputWidget},
    data () {
      return {
        email: '',
        password: '',
        password_confirmation: '',
        token: this.$route.params.token,
        loading: false
      }
    },
    methods: {
      validateForm () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.sendRequestPassword()
          }
        })
      },
      sendRequestPassword () {
        const {email, token, password, password_confirmation} = this
        this.loading = true
        this.$api.post('/v1/auth/password/confirm/' + token, { email: email, password: password, password_confirmation: password_confirmation })
          .then(() => {
            this.$api.post('/v1/auth/login', { email: email, password: password }).then(response => {
              let data = response.data
              if (data.access_token) {
                auth.login(data)
                this.loading = false
                this.$router.push('/organization')
              }
            })
          })
          .catch(error => {
            console.error(error)
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.somethingWentWrong')
            })
            this.loading = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Homepage/ResetPassword.vue